// extracted by mini-css-extract-plugin
export default {"voteValueContainer":"VoteValue_voteValueContainer__c39dX","coffee":"VoteValue_coffee__9PalV","infinity":"VoteValue_infinity__YABlG","value":"VoteValue_value__fJhTk"};